export default ({
  wrapper: {
    height: "65%",
    display: "flex",
    margin: "70px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  form: {
    margin: "20px 0 20px",
    width: "80%",

    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  },

  input: {
    height: "80px",
    fontSize: "18px",
  },

  button: {
    height: "70px",
    fontSize: "20px",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "2px"
  },

  title: {
    color: "#8a8a8a",
    fontSize: "40px",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "5px",
    margin: "5px"
  },

  description: {
    color: "#8a8a8a",
    fontSize: "30px",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "5px",
    margin: "5px"
  },

  lineInfo: {
    color: "#000000a6",
    fontSize: "14px"
  },

  carouselTable: {
    display: "table",
    position: "absolute",
    top: "70px",
    left: 0,
    height: "80%",
    width: "100%",
  },

  carouselItem: {
    verticalAlign: "middle",
    display: "table-cell"
  }
})